import { styled } from '@mui/material';

import CustomAvatar, { CustomAvatarProps } from '../CustomAvatar';

import { AvatarOnlineProps } from './props';

// Styled Avatar component
export const StyledAvatar = styled(CustomAvatar)<
  CustomAvatarProps & { size?: number }
>((props) => ({
  width: props.size ?? 40,
  height: props.size ?? 40,
  fontSize: '1.125rem',
}));

// Styled online status
export const StyledAvatarOnlineStatus = styled('span')<
  Pick<AvatarOnlineProps, 'status'>
>(({ theme, status }) => {
  let background = theme.palette.success.main;

  if (status === 'offline') {
    background = theme.palette.grey[500];
  }
  if (status === 'idle') {
    background = theme.palette.warning.main;
  }

  return {
    width: 8,
    height: 8,
    borderRadius: '50%',
    background,
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
  };
});

export default { StyledAvatarOnlineStatus };
